export const clearToken = (delay = 0) => {
  setTimeout(() => {
    sessionStorage.clear();
    localStorage.clear();
  }, delay);
};
